import { createContext, useContext, useState } from "react";

const VideoUploadPopoverContext = createContext();

export function VideoUploadPopoverProvider({ children }) {
  const [show, setShow] = useState(false);
  const [setVideoUploadProgress, setSetVideoUploadProgress] = useState(() => () => {});

  return (
    <VideoUploadPopoverContext.Provider
      value={{ show, setShow, setVideoUploadProgress, setSetVideoUploadProgress }}
    >
      {children}
    </VideoUploadPopoverContext.Provider>
  );
}

export function useVideoUploadPopover() {
  return useContext(VideoUploadPopoverContext);
}
